module.exports = __webpack_public_path__ + "static/img/nfff.5e9c4b40.png";